import React from 'react';
import { callSources } from '../../data/callSources';
import { formatNumber, formatPercent } from '../../utils/format';
import { sourceTone } from '../../utils/sources';
import type { AgentStats, BlandFunnel, CallSource, VoiceSource } from '../../types/voip';
interface SourceTabsProps {
  voiceTotals: Record<VoiceSource, AgentStats>;
  bland: BlandFunnel;
  value: CallSource;
  onChange: (source: CallSource) => void;
}
export function SourceTabs({
  voiceTotals,
  bland,
  value,
  onChange
}: SourceTabsProps) {
  const headline = (id: CallSource) => {
    if (id === 'bland') {
      return {
        value: formatNumber(bland.opportunities),
        unit: 'opportunities',
        detail: `from ${formatNumber(bland.dials)} dials`
      };
    }
    const s = voiceTotals[id];
    return {
      value: formatNumber(s.totalCalls),
      unit: 'calls',
      detail: `${formatPercent(s.answerRate)} answer rate`
    };
  };
  return <div role="radiogroup" aria-label="Call source" className="grid gap-3 sm:grid-cols-3" data-id="element-312" data-mp="2q5702ibhl350">
      {callSources.map(s => {
      const active = s.id === value;
      const h = headline(s.id);
      return <button key={s.id} type="button" role="radio" aria-checked={active} onClick={() => onChange(s.id)} className={`flex items-center justify-between gap-4 rounded-xl border px-4 py-3.5 text-left transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent ${active ? 'border-accent bg-accent-soft/50' : 'border-line bg-surface shadow-card hover:border-accent/30'}`} data-id="element-313" data-mp="3a8if6u8ungxd">
            <span className="min-w-0" data-id="element-314" data-mp="3k0xtnhkxtndi">
              <span className="flex items-center gap-2 text-sm font-semibold text-ink" data-id="element-315" data-mp="3jzwi7c00eyv9">
                <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${sourceTone[s.id].dot}`} aria-hidden data-id="element-316" data-mp="2dl5bgro7gjtb" />
                {s.label}
              </span>
              <span className="mt-0.5 block truncate text-xs text-muted" data-id="element-317" data-mp="2a2etwshldr6g">{s.description}</span>
            </span>
            <span className="shrink-0 text-right" data-id="element-318" data-mp="2f219h8kw7jif">
              <span className="block whitespace-nowrap font-display text-lg font-bold leading-tight text-ink" data-id="element-319" data-mp="2f0q5p8rg6brb">
                {h.value} <span className="font-sans text-xs font-medium text-muted" data-id="element-320" data-mp="2142uc0yqzj1v">{h.unit}</span>
              </span>
              <span className="block whitespace-nowrap text-[11px] text-subtle" data-id="element-321" data-mp="1rbx7f5ncrrtj">{h.detail}</span>
            </span>
          </button>;
    })}
    </div>;
}